var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeScaleDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6096 1.98077V14.6312",
    stroke: "#8DBEFF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.693 14.9121H1.73438",
    stroke: "#8DBEFF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6285 1.98067H3.84259C2.43699 1.98067 1.3125 3.10516 1.3125 4.51076V125.814C1.3125 127.22 2.43699 128.344 3.84259 128.344H27.3162",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.819 59.3289V4.51033C127.819 3.10473 126.695 1.98024 125.289 1.98024H104.064",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6096 128.485H125.147C126.552 128.485 127.677 127.36 127.677 125.955V68.4656",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3852 82.0997L39.4054 76.6179L29.285 82.0997V61.9996H49.3852V82.0997Z",
    fill: "url(#paint0_linear_6619_1781)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8184 66.3571C57.8184 67.4816 58.8023 68.4655 59.9268 68.4655H73.1394C73.9828 68.4655 74.545 69.1683 74.545 69.8711V73.9474C74.545 75.2124 76.0912 75.9152 77.0751 74.9313L83.1192 68.8872C83.4003 68.6061 83.822 68.4655 84.1031 68.4655H115.87C116.994 68.4655 117.978 67.4816 117.978 66.3571V13.7876C117.978 12.6631 116.994 11.6791 115.87 11.6791H59.9268C58.8023 11.6791 57.8184 12.6631 57.8184 13.7876V66.3571Z",
    fill: "#4796FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.733 43.1645C106.593 45.554 104.625 47.6624 102.235 47.803C101.673 47.803 101.111 47.803 100.549 47.5219C100.267 47.3813 99.9863 47.6624 99.9863 47.9435V56.6583C99.9863 57.3611 99.424 57.9233 98.7212 57.9233H90.0065C89.7254 57.9233 89.4443 57.6422 89.5848 57.3611C89.7254 56.7989 89.8659 56.2366 89.8659 55.6744C89.7254 53.2848 87.7576 51.1764 85.2275 51.1764C82.5568 51.0359 80.3079 53.2848 80.3079 55.9555C80.3079 56.5177 80.4484 56.9394 80.589 57.3611C80.7295 57.6422 80.4484 57.9233 80.1673 57.9233H71.4526C70.7498 57.9233 70.1875 57.3611 70.1875 56.6583V47.9435C70.1875 47.6624 70.4686 47.3813 70.7498 47.5219C71.312 47.6624 71.8742 47.803 72.4365 47.803C74.826 47.6624 76.9344 45.6946 76.9344 43.1645C77.075 40.4939 74.826 38.2449 72.1554 38.2449C71.5931 38.2449 71.1714 38.3855 70.7498 38.526C70.4686 38.6666 70.1875 38.3854 70.1875 38.1043V29.3896C70.1875 28.6868 70.7498 28.1246 71.4526 28.1246H80.1673C80.4484 28.1246 80.7295 27.8434 80.589 27.5623C80.4484 27.1406 80.3079 26.5784 80.3079 26.1567C80.3079 23.4861 82.4163 21.3777 85.0869 21.3777C87.7575 21.3777 89.8659 23.4861 89.8659 26.1567C89.8659 26.7189 89.7254 27.1406 89.5848 27.5623C89.4443 27.8434 89.7254 28.1246 90.0065 28.1246H98.7212C99.424 28.1246 99.9863 28.6868 99.9863 29.3896V38.1043C99.9863 38.3854 100.267 38.6666 100.549 38.526C100.97 38.3855 101.532 38.2449 101.954 38.2449C104.765 38.2449 106.874 40.4939 106.733 43.1645Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.733 43.1645C106.593 45.554 104.625 47.6624 102.235 47.803C101.673 47.803 101.111 47.803 100.549 47.5219C100.267 47.3813 99.9863 47.6624 99.9863 47.9435V56.6583C99.9863 57.3611 99.4241 57.9233 98.7212 57.9233H90.0065C89.7254 57.9233 89.4443 57.6422 89.5848 57.3611C89.7254 56.7989 89.8659 56.2366 89.8659 55.6744C89.7254 53.2848 87.7576 51.1764 85.2275 51.1764C82.5568 51.0359 80.3079 53.2848 80.3079 55.9555C80.3079 56.5177 80.4484 56.9394 80.589 57.3611C80.7295 57.6422 80.4484 57.9233 80.1673 57.9233H71.4526C70.7498 57.9233 70.1875 57.3611 70.1875 56.6583V47.9435C70.1875 47.6624 70.4686 47.3813 70.7498 47.5219C71.312 47.6624 71.8742 47.803 72.4365 47.803C74.826 47.6624 76.9344 45.6946 76.9344 43.1645C77.075 40.4939 74.826 38.2449 72.1554 38.2449C71.5931 38.2449 71.1714 38.3855 70.7498 38.526C70.4686 38.6666 70.1875 38.3854 70.1875 38.1043V29.3896C70.1875 28.6868 70.7498 28.1246 71.4526 28.1246H80.1673C80.4484 28.1246 80.7295 27.8434 80.589 27.5623C80.4484 27.1406 80.3079 26.5784 80.3079 26.1567C80.3079 23.4861 82.4163 21.3777 85.0869 21.3777C87.7575 21.3777 89.8659 23.4861 89.8659 26.1567C89.8659 26.7189 89.7254 27.1406 89.5848 27.5623C89.4443 27.8434 89.7254 28.1246 90.0065 28.1246H98.7212C99.4241 28.1246 99.9863 28.6868 99.9863 29.3896V38.1043C99.9863 38.3854 100.267 38.6666 100.549 38.526C100.97 38.3855 101.532 38.2449 101.954 38.2449C104.765 38.2449 106.874 40.4939 106.733 43.1645Z",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3852 61.9995V80.1318C49.3852 80.9752 48.5418 81.3968 47.839 81.1157L39.8271 77.18C39.5459 77.0395 39.1243 77.0395 38.8431 77.18L30.8312 81.1157C30.1284 81.5374 29.285 80.9752 29.285 80.1318V61.9995",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0968 36.8392L87.4744 42.4616C87.0527 42.8833 86.3499 42.8833 85.9282 42.4616L82.6953 39.2287",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7987 87.3006V68.7466",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5371 61.8592H15.2285C12.8389 61.8592 10.8711 63.827 10.8711 66.2166V114.429C10.8711 116.818 12.8389 118.786 15.2285 118.786H63.5812C65.9707 118.786 67.9386 116.818 67.9386 114.429V94.8909",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8184 37.9639V66.3571C57.8184 67.4816 58.8023 68.4655 59.9268 68.4655H73.1394C73.9828 68.4655 74.545 69.1683 74.545 69.8711V73.9474C74.545 75.2124 76.0912 75.9152 77.0751 74.9313L83.1192 68.8872C83.4003 68.6061 83.822 68.4655 84.1031 68.4655H115.87C116.994 68.4655 117.978 67.4816 117.978 66.3571V13.7876C117.978 12.6631 116.994 11.6792 115.87 11.6792H59.9268C58.8023 11.6792 57.8184 12.6631 57.8184 13.7876V30.3737",
    stroke: "#0069FF",
    strokeWidth: 2.40963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6619_1781",
    x1: 29.3439,
    y1: 72.0878,
    x2: 56.1297,
    y2: 72.0878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DBEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeScaleDev);
export default __webpack_public_path__ + "static/media/large-scale-dev.e256359c3982411a3ce4c2cee452949c.svg";
export { ForwardRef as ReactComponent };